import React from 'react'
import PageControls from '../PageControls/PageControls'
import Title from '../title/Title'
import formatDate from '../../functions/formatDate'
import malak from '../../assets/svg/Group -25.svg'
import abrar from '../../assets/svg/Group 92.svg'
import yazeed from '../../assets/svg/Group 91.svg'
import dina from '../../assets/svg/Group 90.svg'
import User from '../user/User'
import sessionImg from '../../assets/png/brainstormingEl.png'
const users = [{name:'Malak' , img:malak }, {name:'Dina' , img:dina },{name:'Yazeed' , img:yazeed },{name:'Abrar' , img:abrar } ]

export default function YourSession({nextPage}) {
    return (
        <div className="brainstorming">
<PageControls nextPage={nextPage} /> 
            <Title title={'Your Sessions'} subtitle={formatDate(new Date)} />
            <div className="flex">
                <div className="sectionImg">

        <img className="" src={sessionImg} alt=""/>
                </div>
        <div className="SessionDetails">
            
            <h1>Brainstorming</h1>
            <p>{formatDate(new Date, true)} @ 11:00 am</p>
        <select className="SessionSelect" name="" id="">
        <option disabled selected>Brainstorming agenda</option>
        </select>
            <p>Attending Team members:</p>
            <div className="users">
                {users.map(el =><User width="70px" el={el} /> )}
            </div>
            <button className="next" onClick={()=>nextPage(1)} >Start Session</button>
        </div>
        </div>

        </div>
    )
}
